export default __webpack_public_path__ + "static/media/forgot_password_3.3f36ba58.svg";